import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Bulk-Massenspeicher-Pool (Hetzner Storage Boxen). Nur lesend — jede Box ist
 * eine k8s-StorageClass, Belegung = Σ gebuchte GB der Pods je Box. Eine als
 * `isUnion` markierte Box (mergerfs/rclone-union) gilt als praktisch unbegrenzt.
 * M2M-Auth wie alle /v1/admin/*-Endpoints.
 */
const FIXTURE = {
  boxes: [
    { id: 1, name: 'sb-fsn1-01', provider: 'hetzner-storagebox', storageClass: 'bulk-sb-fsn1-01', capacityGb: 5120, reservedGb: 200, usedGb: 3100, freeGb: 1820, isUnion: false, active: true, notes: 'Falkenstein', usedPct: 61 },
    { id: 2, name: 'sb-nbg1-02', provider: 'hetzner-storagebox', storageClass: 'bulk-sb-nbg1-02', capacityGb: 10240, reservedGb: 0, usedGb: 9600, freeGb: 640, isUnion: false, active: true, notes: null, usedPct: 94 },
    { id: 3, name: 'union-all', provider: 'mergerfs', storageClass: 'bulk-union', capacityGb: 0, reservedGb: 0, usedGb: 1400, freeGb: null, isUnion: true, active: true, notes: 'Auffang-Union', usedPct: null },
  ],
};

export function useBulkBoxes() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['bulk-boxes', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/bulk-boxes');
    },
    refetchInterval: 60_000,
  });
}
